import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-list-skeletal',
  template: `
  <div class="skeleton p-0 m-0">
    <div class="skeleton_list_section" [ngStyle]="{ rowGap: rowGap + 'px' }">
      <ng-container *ngFor="let row of this.getTotalRows();">
         <div class="line skeleton_list_section" [ngClass]="{'border_radius_6':borderRadiusEnabled}" [ngStyle]="{ height: rowheight + 'px' }"></div>
      </ng-container>
    </div>
  </div>
`,
  styles: [
    `
.skeleton_list_section {
flex: 1 1 auto;
}

.border_radius_6{
border-radius: 6px;
}

.skeleton_list_section {
display: flex;
flex-direction: column;
}
`]
})
export class ListSkeletalComponent {
  @Input() rows: number = 5;
  @Input() rowheight: number = 45
  @Input() rowGap: number = 8;
  @Input() borderRadiusEnabled = false;

  constructor() { }

  ngOnInit(): void {
  }

  getTotalRows(): number[] {
    return Array.from({ length: this.rows }, (_, i) => i);
  }
}
